import { render, staticRenderFns } from "./LayoutClinicCust.vue?vue&type=template&id=ad49a2e0&scoped=true&"
import script from "./LayoutClinicCust.vue?vue&type=script&lang=js&"
export * from "./LayoutClinicCust.vue?vue&type=script&lang=js&"
import style1 from "./LayoutClinicCust.vue?vue&type=style&index=1&id=ad49a2e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad49a2e0",
  null
  
)

export default component.exports